<template>
    <div style="border-radius: 12px; background-color: #F5F5F5; padding: 12px; display: flex; flex-direction: column;">
        <div style="display: flex; align-items: center; gap: 10px;">
            <div>
                <ProfileImage style="width: 40px;" :image-path="feedbackInfo.image_path"></ProfileImage>
            </div>
            <div style="display: flex; flex-direction: column; gap: 5px;">
                <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
                    <div style="font-weight: 700; font-size: 14px;">{{ feedbackInfo.nic_name }}</div>
                    <div style="margin-left: 4px;">
                        <img v-if="feedbackInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                    </div>
                </div>
                <div style="font-size: 12px; color: #606060;">{{ feedbackInfo.team_name }}</div>
            </div>
        </div>
        <div @click="showFullText" style="margin-top: 8px; flex: 1; display: flex; flex-direction: column; padding-left: 51px;">
            <div style="flex: 1;">
                <div class="ellipsis" ref="contents" style="font-weight: 500; font-size: 14px; line-height: 20px; word-break: break-all;">{{ feedbackInfo.contents }}</div>
                <div v-if="isShowSeeMoreBtn" style="font-weight: 700; font-size: 14px; margin-top: 8px; color: var(--color-main);">더보기</div>
            </div>
            <div class="like_wrap">
                <div :class="feedbackInfo.like_yn == IS_LIKE.LIKE ? 'active' : ''" class="like_btn">
                    <img src="@/assets/img/thumbs_up_white.png">
                    <span>도움이 되었어요</span>
                    <span style="margin-left: 5px;">{{ feedbackInfo.like_number }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { TEAM_TYPE, FEEDBACK_MODE, IS_LIKE } from '@/Constants'

export default {
    name: 'ExpertFeedbackWrapper',
    components: { ProfileImage },
    props: {
        feedbackInfo: {
            type: Object,
            default: () => {}
        },
        setLikeState: {
            type: Function,
            default: () => {}
        },
        index: {
            type: Number,
            default: -1
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            FEEDBACK_MODE: FEEDBACK_MODE,
            TEAM_TYPE: TEAM_TYPE,
            IS_LIKE: IS_LIKE,
            isShowSeeMoreBtn: false
        }
    },
    created() {
        this.$nextTick(() => {
            const contentsHeight = this.$refs.contents.scrollHeight;
            if (contentsHeight > 60) {
                this.isShowSeeMoreBtn = true;
            }
            
        })
    },
    methods: {
        showFullText() {
            this.$GlobalStore.addModal('ExpertFeedbackModal', { 
                feedbackInfo: this.feedbackInfo,
                transitionName: '',
                isModalBackTransparent: true,
                feedbackMode: FEEDBACK_MODE.VIEW,
                setLikeState: this.setLikeState,
                index: this.index,
                completeAction: this.completeAction
            })
        },
    }
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
   -webkit-box-orient: vertical
}

.like_wrap {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}

.like_btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    padding: 6px 10px;
    border-radius: 20px;
    background: #210f03;
}

.like_btn img {
    width: 16px;
}

.like_btn.active {
    background: var(--color-main);
}
</style>